export const primaryColor = "rgb(136, 114, 59)";
export const secondaryColor = "#000000";
export const primaryDarkColor = "#6e3c1d";
export const secondaryDarkColor = "#4b4b4b";
export const colorOverBody = "black";